<template>
  <BaseModal v-bind="modalUsuario">
    <template v-slot:header>
      <h3>Editar usuário</h3>
    </template>

    <template v-slot:default>
      <BaseProgressBar v-if="loading" v-bind="progressBar"
        >Carregando dados do usuário...</BaseProgressBar
      >
      <div v-else>
        <InfoCard v-bind="infoCard">
          <p>
            Para remover um perfil do usuário, basta clicar no respectivo ícone
            de fechar. Para adicionar um perfil, digite um trecho do nome do
            perfil e escolha o item desejado dentre as opções da lista suspensa
            que será exibida. Também pode-se (des)associar permissões avulsas ao
            usuário, realizando o mesmo passo a passo da (des)associação de
            perfis.
          </p>
        </InfoCard>

        <!-- TODO: melhorar a forma de evitar o margin collapse -->
        <BaseBuscaUsuarioItem
          tag="h4"
          v-bind:value="usuario"
          class="usuario-info"
        />

        <section class="section">
          <h4>Perfis</h4>

          <div class="row">
            <BaseTypeahead
              ref="perfilTypeahead"
              v-bind="perfilTypeahead"
              v-on:change="addPerfil"
            />
          </div>

          <BaseChip
            v-for="(item, index) in usuario.perfis"
            v-bind:key="index"
            v-bind:id="`${id}-perfil-${item.id}`"
            tabindex="0"
            v-on:delete="deletePerfil(index)"
            >{{ item.nome }}</BaseChip
          >
        </section>
        <section class="section">
          <h4>Permissões avulsas</h4>

          <div class="row">
            <BaseTypeahead
              ref="permissaoTypeahead"
              v-bind="permissaoTypeahead"
              v-on:change="addPermissao"
            />
          </div>

          <BaseChip
            v-for="(item, index) in usuario.permissoes"
            v-bind:key="index"
            v-bind:id="`${id}-permissao-${item.id}`"
            tabindex="0"
            v-on:delete="deletePermissao(index)"
            >{{ item.nome }}</BaseChip
          >
        </section>
      </div>
    </template>

    <template v-slot:footer>
      <BaseButton
        class="modal-close"
        v-bind:disabled="disabled"
        material-type="flat"
        >Cancelar</BaseButton
      >
      <BaseButton
        material-type="flat"
        v-bind:disabled="disabled"
        v-on:click="save"
        >Salvar</BaseButton
      >
    </template>
  </BaseModal>
</template>

<script>
import { API_URL } from "../../constants";
import BaseBuscaUsuarioItem from "./BaseBuscaUsuarioItem.vue";

const defaultUsuario = {
  nome: null,
  tipo: null,
  servidorResponsavel: {
    nome: null,
    cpf: null
  }
};

export default {
  name: "UsuarioModal",
  components: {
    BaseBuscaUsuarioItem
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    value: Object
  },
  data() {
    return {
      disabled: false,
      loading: false,
      saving: false,
      infoCard: {
        id: `${this.id}-infocard`,
        title: "Edição de usuário"
      },
      usuario: {
        ...defaultUsuario,
        permissoes: [],
        perfis: []
      },
      usuarioOriginal: {
        ...defaultUsuario,
        permissoes: [],
        perfis: []
      },
      perfisMap: {},
      permissoesMap: {},
      perfilTypeahead: {
        id: `${this.id}-perfil-typeahead`,
        name: "perfil",
        label: "Perfil",
        placeholder: "Busque pelo nome do perfil",
        dropdownId: `${this.id}-perfil-dropdown`,
        searchFunction: this.searchPerfil,
        gridExpression: "col s12"
      },
      permissaoTypeahead: {
        id: `${this.id}-permissao-typeahead`,
        name: "permissao",
        label: "Permissão",
        placeholder: "Busque pelo nome da permissão",
        dropdownId: `${this.id}-permissao-dropdown`,
        searchFunction: this.searchPermissao,
        gridExpression: "col s12"
      },
      modalUsuario: {
        id: this.id,
        hasFixedFooter: true,
        modalOptions: {
          onOpenStart: this.onModalOpen,
          dismissible: false
        }
      },
      progressBar: {
        useContainer: false
      }
    };
  },
  methods: {
    addPerfil(item) {
      if (!item) {
        return;
      }

      // Verifica, a partir de um map de controle, se o perfil
      // já foi adicionado no array
      if (!this.perfisMap[item.id]) {
        this.usuario.perfis.push(
          this.$utils.Components.fromDropdownItem(item, "id", "nome")
        );
        this.perfisMap[item.id] = true;
      }

      // Limpa o typeahead
      this.$refs.perfilTypeahead.clear();
    },
    addPermissao(item) {
      if (!item) {
        return;
      }

      // Verifica, a partir de um map de controle, se a permissão
      // já foi adicionada no array
      if (!this.permissoesMap[item.id]) {
        this.usuario.permissoes.push(
          this.$utils.Components.fromDropdownItem(item, "id", "nome")
        );
        this.permissoesMap[item.id] = true;
      }

      // Limpa o typeahead
      this.$refs.permissaoTypeahead.clear();
    },
    deletePerfil(index) {
      if (index >= 0) {
        delete this.perfisMap[this.usuario.perfis[index].id];
        this.usuario.perfis.splice(index, 1);
      }
    },
    deletePermissao(index) {
      if (index >= 0) {
        delete this.permissoesMap[this.usuario.permissoes[index].id];
        this.usuario.permissoes.splice(index, 1);
      }
    },
    onModalOpen() {
      // Reseta algumas variáveis
      this.disabled = false;
      this.loading = false;
      this.saving = false;
      this.usuario = {
        permissoes: [],
        perfis: []
      };
      this.usuarioOriginal = {
        permissoes: [],
        perfis: []
      };
      this.perfisMap = {};
      this.permissoesMap = {};
      // Limpa os typeaheads
      this.$refs.perfilTypeahead.clear();
      this.$refs.permissaoTypeahead.clear();

      this.usuario.id = this.usuarioOriginal.id = this.value.id;
      this.usuario.nome = this.usuarioOriginal.nome = this.value.nome;
      this.usuario.tipo = this.usuarioOriginal.tipo = this.value.tipo;
      this.usuario.servidorResponsavel =
        this.usuarioOriginal.servidorResponsavel =
          this.value.servidorResponsavel;

      this.loading = true;

      const usuarioId = this.usuario.id;

      Promise.all([
        this.$http.get(`${API_URL}/acesso/usuario/${usuarioId}/perfil`),
        this.$http.get(`${API_URL}/acesso/usuario/${usuarioId}/permissao`)
      ])
        .then(responses => {
          this.usuario.perfis = responses[0].data || [];
          this.usuario.permissoes = responses[1].data || [];

          this.usuarioOriginal.perfis = this.usuario.perfis.map(item => ({
            ...item
          }));
          this.usuarioOriginal.permissoes = this.usuario.permissoes.map(
            item => ({ ...item })
          );

          this.usuario.perfis.forEach(item => (this.perfisMap[item.id] = true));
          this.usuario.permissoes.forEach(
            item => (this.permissoesMap[item.id] = true)
          );
        })
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao obter os dados do usuário: ${error.message}`
          )
        )
        .finally(() => (this.loading = false));
    },
    getPerfilPutData() {
      const putData = [];

      this.usuario.perfis.forEach(item => {
        const isItemFound =
          this.usuarioOriginal.perfis.findIndex(
            originalItem => originalItem.id === item.id
          ) >= 0;

        if (!isItemFound) {
          putData.push(item);
        }
      });

      return putData;
    },
    getPermissaoPostData() {
      const putData = [];

      this.usuario.permissoes.forEach(item => {
        const isItemFound =
          this.usuarioOriginal.permissoes.findIndex(
            originalItem => originalItem.id === item.id
          ) >= 0;

        if (!isItemFound) {
          putData.push(item);
        }
      });

      return putData;
    },
    getPerfilDeleteData() {
      const deleteData = [];
      const perfis = this.usuario.perfis;

      this.usuarioOriginal.perfis.forEach(originalItem => {
        const isItemFound =
          perfis.findIndex(item => originalItem.id === item.id) >= 0;

        if (!isItemFound) {
          deleteData.push(originalItem);
        }
      });

      return deleteData;
    },
    getPermissaoDeleteData() {
      const deleteData = [];
      const permissoes = this.usuario.permissoes;

      this.usuarioOriginal.permissoes.forEach(originalItem => {
        const isItemFound =
          permissoes.findIndex(item => originalItem.id === item.id) >= 0;

        if (!isItemFound) {
          deleteData.push(originalItem);
        }
      });

      return deleteData;
    },
    save() {
      const usuarioId = this.value.id;

      this.disabled = true;
      this.saving = true;

      const perfilPutData = this.getPerfilPutData();
      const permissaoPostData = this.getPermissaoPostData();
      const perfilDeleteData = this.getPerfilDeleteData();
      const permissaoDeleteData = this.getPermissaoDeleteData();

      const saveData = [].concat(
        perfilPutData.map(item =>
          this.$http
            .put(`${API_URL}/acesso/perfil/${item.id}/usuario/${usuarioId}`)
            .then(() => {
              // Atualiza os registros originais cujos correspondentes foram
              // criados com sucesso para que, em caso de erro, os mesmos não
              // sejam reenviados ao servidor desnecessariamente.
              this.usuarioOriginal.perfis.push(item);

              this.$notification.pushSuccess(
                `Perfil "${item.nome}" associado ao usuário com sucesso`
              );
            })
        ),
        permissaoPostData.map(item =>
          this.$http
            .post(`${API_URL}/acesso/usuario/${usuarioId}/permissao/${item.id}`)
            .then(() => {
              // Atualiza os registros originais cujos correspondentes foram
              // criados com sucesso para que, em caso de erro, os mesmos não
              // sejam reenviados ao servidor desnecessariamente.
              this.usuarioOriginal.permissoes.push(item);

              this.$notification.pushSuccess(
                `Permissão "${item.nome}" associada ao usuário com sucesso`
              );
            })
        ),
        perfilDeleteData.map(item =>
          this.$http
            .delete(`${API_URL}/acesso/perfil/${item.id}/usuario/${usuarioId}`)
            .then(() => {
              const index = this.usuarioOriginal.perfis.findIndex(
                itemOriginal => itemOriginal.id === item.id
              );

              // Atualiza os registros originais cujos correspondentes foram
              // excluídos com sucesso para que, em caso de erro, os mesmos não
              // sejam reenviados ao servidor desnecessariamente.
              if (index >= 0) {
                this.usuarioOriginal.perfis.splice(index, 1);
              }

              this.$notification.pushSuccess(
                `Perfil "${item.nome}" desassociado do usuário com sucesso`
              );
            })
        ),
        permissaoDeleteData.map(item =>
          this.$http
            .delete(
              `${API_URL}/acesso/usuario/${usuarioId}/permissao/${item.id}`
            )
            .then(() => {
              const index = this.usuarioOriginal.permissoes.findIndex(
                itemOriginal => itemOriginal.id === item.id
              );

              // Atualiza os registros originais cujos correspondentes foram
              // excluídos com sucesso para que, em caso de erro, os mesmos não
              // sejam reenviados ao servidor desnecessariamente.
              if (index >= 0) {
                this.usuarioOriginal.permissoes.splice(index, 1);
              }

              this.$notification.pushSuccess(
                `Permissão "${item.nome}" desassociado do usuário com sucesso`
              );
            })
        )
      );

      Promise.all(saveData)
        .then(() => this.$utils.Components.closeModal(this.id))
        .catch(error => {
          this.$notification.pushError(
            `Houve um erro ao atualizar usuário: ${error.message}`
          );
        })
        .finally(() => {
          this.disabled = false;
          this.saving = false;
        });
    },
    searchPerfil(value) {
      return this.$http
        .get(`${API_URL}/acesso/perfil/busca?query=${value}`)
        .then(response =>
          (response.data || []).map(item =>
            this.$utils.Components.toDropdownItem(item, "id", "nome")
          )
        )
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao buscar pelo perfil: ${error.message}`
          )
        );
    },
    searchPermissao(value) {
      return this.$http
        .get(`${API_URL}/acesso/permissao/busca?query=${value}`)
        .then(response =>
          (response.data || []).map(item =>
            this.$utils.Components.toDropdownItem(item, "id", "nome")
          )
        )
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao buscar pela permissão: ${error.message}`
          )
        );
    }
  }
};
</script>

<style scoped>
h3 {
  font-size: 2.28rem;
  margin: 1.52rem 0 0.912rem 0;
}

h4 {
  font-size: 1.64rem;
  margin: 1.0933333333rem 0 0.656rem 0;
}

.usuario-info {
  padding: 1px 0;
}
.usuario-info /deep/ h4 {
  font-size: 1.64rem;
  margin: 1.0933333333rem 0 0.656rem 0;
}
.usuario-info /deep/ h5 {
  font-size: 1.15rem;
  margin: 0.7666666667rem 0 0.46rem 0;
}
</style>
